import React from 'react';
import { observer } from 'mobx-react-lite';
import { TableRow, TableCell } from '@material-ui/core';
import { UserActivity } from '../../../types';

type CELL = {
  name: keyof UserActivity | 'username' | 'email';
  render?: (data: UserActivity, cell: CELL) => string;
};

const CELLS: CELL[] = [
  { name: 'id' },
  {
    name: 'username',
    render: (data): string => data.user?.username || '-',
  },
  {
    name: 'email',
    render: (data): string => data.user?.email || '-',
  },
  { name: 'action' },
  {
    name: 'createdAt',
    render: (data): string => new Date(data.createdAt).toLocaleString(undefined, {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    }),
  },
];

type Props = {
  data: UserActivity;
};

export const UserActivityItem: React.FC<Props> = observer(({ data }) => (
  <TableRow hover>
    {CELLS.map((cell) => (
      <TableCell key={String(cell.name)}>
        {cell.render ? cell.render(data, cell) : data[cell.name]}
      </TableCell>
    ))}
  </TableRow>
));
